import BuyAirtime from '../../pages/PayBills/BuyAirtime';
import { object, string, number } from 'yup';
import constant from '../../utils/constant';
import React from 'react';
import { observer } from 'mobx-react';
import { billStore } from '../../stores';
import { phoneRegExp } from '../../utils/utils';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const BuyAirtimeContainer = ({ closeModal, pinContent, setPinContent, setShowSurvey }) => {

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.PAYBILLSBUYAIRTIMEDATA);

	const validationSchema = () =>
		object({
			phone: string().matches(phoneRegExp, 'Phone number is not valid').required('Please enter phone number'),
			networkId: string().required('Please select network'),
			amount: number()
				.required('Please enter amount')
				.min(100, 'The minimum Airtime to purchase is N100'),
		});

	const onSubmit = async payload => {
		delete payload.networkName;
		payload.controller = 'buyAirtime';
		localStorage.setItem(constant.RouteParams, JSON.stringify(payload));
		setPinContent(true);
	};

	return (
		<BuyAirtime
			bill={billStore.copiedBill}
			pinContent={pinContent}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			closeModal={closeModal}
			needFeedback={needFeedback}
			setShowSurvey={setShowSurvey}
		/>
	);
};

export default observer(BuyAirtimeContainer);
